import { render, staticRenderFns } from "./Custom-dashboard.vue?vue&type=template&id=68d78a8f"
import script from "./Custom-dashboard.vue?vue&type=script&lang=js"
export * from "./Custom-dashboard.vue?vue&type=script&lang=js"
import style0 from "./Custom-dashboard.vue?vue&type=style&index=0&id=68d78a8f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports